import React from 'react';
import arrow from './arrow.svg';
import timezoneIcon from './timezone_icon.svg';

type SelectProps = {
  children: JSX.Element[];
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  value: string | undefined;
  name?: string;
  className?: string;
  size?: number;
};

export const Select: React.FC<SelectProps> = ({
  children,
  onChange,
  value,
  name,
  className,
  size,
}: SelectProps): JSX.Element => {
  return (
    <div className="select-container">
      <select
        size={size}
        value={value}
        name={name}
        onChange={onChange}
        className={`${className} select`}
      >
        {children}
      </select>
      <img src={arrow} alt="Arrow" className="select-container__imgArrow" />
      {name === 'timezone' ? (
        <img src={timezoneIcon} alt="tz" className="select-container__iconTZ" />
      ) : (
        <></>
      )}
    </div>
  );
};
